import { useState, useEffect, useCallback } from 'react';
import { getAdminWallets, getAdminTotalBalances } from '../../API/ProtectedAuth';

export const useAdminWallets = () => {
    const [wallets, setWallets] = useState([]);
    const [stats, setStats] = useState(null);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
        search: '',
        page: 1
    });

    const fetchWallets = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getAdminWallets(filters);
            setWallets(data.wallets);
            setTotal(data.total);
        } catch (err) {
            setError(err);
            console.error('Error fetching admin wallets:', err);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    const fetchStats = useCallback(async () => {
        setStatsLoading(true);
        try {
            const response = await getAdminTotalBalances();
            setStats(response.data);
        } catch (err) {
            console.error('Error fetching wallet statistics:', err);
        } finally {
            setStatsLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchWallets();
    }, [fetchWallets]);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    const setPage = (page) => {
        setFilters(prev => ({ ...prev, page }));
    };

    const setSearch = (search) => {
        setFilters(prev => ({ ...prev, search, page: 1 }));
    };

    const refresh = () => {
        fetchWallets();
        fetchStats();
    };

    return {
        wallets,
        stats,
        total,
        loading,
        statsLoading,
        error,
        filters,
        setFilters,
        setPage,
        setSearch,
        refresh
    };
};
